import { getTeamPageUrl } from "../../../../utils/urls"
import { LocalizedMatch } from "../../../../types/match"
import { DivergentStackedBarData } from "../../../../apis/MatchAPI"
import { DivergentStackedBar } from "@components/Graph/DivergentStackedBar/DivergentStackedBar"

export function MatchStatistics({
  match,
  matchStats,
  showHeader,
}: {
  match: LocalizedMatch
  matchStats: DivergentStackedBarData[]
  showHeader: boolean
}) {
  const teamHomeUrl = getTeamPageUrl(
    match.homeTeam!.calciocomSlug!,
    match.competition?.calciocomSlug,
    match.season?.calciocomSlug,
  )
  const teamAwayUrl = getTeamPageUrl(
    match.awayTeam!.calciocomSlug!,
    match.competition?.calciocomSlug,
    match.season?.calciocomSlug,
  )

  return (
    <DivergentStackedBar
      match={match}
      teamHomeUrl={teamHomeUrl}
      teamAwayUrl={teamAwayUrl}
      data={matchStats}
      showHeader={showHeader}
    />
  )
}
